import { Link } from '@amzn/awsui-components-core';
import {
  ContentMetadata,
  ContentType,
  ContentTypeMetadata,
  ContentWorkflow,
  UserType,
} from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import { getContentTemplateSchema } from '../../api/UtilsApi';
import constants from '../../common/constants';
import { AppContext } from '../../contexts/AppContext';
import { ContentSchemaSection } from '../../model/ContentSchemaSection';

interface Props {
  contentType: ContentType;
  schemaSection: ContentSchemaSection;
  sectionId?: string;
}

const TutorialLink = (props: Props) => {
  const appContext = useContext(AppContext);
  const { contentType, sectionId, schemaSection } = props;
  const userType = appContext?.authnInfo?.userProfile.type;

  const schema = getContentTemplateSchema(contentType, new ContentTypeMetadata(), schemaSection);

  const tutorialLink = sectionId
    ? schema?.properties[sectionId]?.infoLink
    : schema?.properties?.infoLink?.const;

  return userType === UserType.AWS && tutorialLink ? (
    <Link external href={tutorialLink} variant="info">
      {constants.WATCH_TUTORIAL}
    </Link>
  ) : contentType === ContentType.Guide ? (
    <Link external href={constants.GUIDE_TRAINING_LINK} variant="info">
      {constants.WATCH_TUTORIAL}
    </Link>
  ) : null;
};

export default TutorialLink;
